import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'tnc',
    defaultMessage: 'Syarat & Ketentuan',
  },
  checkboxAgree: {
    id: 'tnc.checkbox.agree',
    defaultMessage: 'I agree to the Terms & Conditions.',
  },
  btnContinue: {
    id: 'tnc.btn.continue',
    defaultMessage: 'CONTINUE',
  },
});
